import React, { useState } from 'react';
import { CabTypesAvailableForRent } from '../../pages/runtime-typechecker';
import RouteCarTypeCabs from '../RouteCarTypeCabs/RouteCarTypeCabs';
import styles from '../HourlyRentalsCabs/HourlyRentalsCabs.module.css';
import { Context } from '../../AppContext';
import { CITY_HR, HR_STRING } from '../../constants/miscellaneousConstants';
import SelectPackage from '../SelectPackage/SelectPackage';
import capitalise from '../../utils/capitalise';

type RouteCarTypeCabsForHRProps = {
  cityName: string;
  cabsAvailableForRent: CabTypesAvailableForRent;
  h2String?: string;
  showCityNameOnCabCard?: boolean;
};
const HourlyRentalsCabs = ({
  cityName,
  cabsAvailableForRent: data,
  h2String,
  showCityNameOnCabCard = false
}: RouteCarTypeCabsForHRProps) => {
  const { trackTemplateEvent } = React.useContext(Context);

  const packages =
    data && data.packages && data.packages.length > 0
      ? data.packages.map(p => p.duration + ' ' + p.distance)
      : [];
  const [selectedPackage, setPackage] = useState(0);

  const onPackageSelect = (idx: number) => {
    setPackage(idx);
    trackTemplateEvent(`Cab_SEO_${packages[idx].replace(/\s/g, '')}_Select`);
  };
  return packages.length > 0 ? (
    <>
      <section className="visibilityAuto">
        {h2String ? <h2 className={``}>{h2String}</h2> : null}
        <div className={`${styles.modelSectionFlex}`}>
          {
            <>
              <div className={`${styles.modelSectionHeading} `}>
                <p className="selectPackageHeading">Select package</p>
                <p className="selectPackageSuheading">
                  Basis duration &amp; kms
                </p>
              </div>
            </>
          }
          <SelectPackage
            selectedPackage={selectedPackage}
            packages={packages}
            onPackageSelect={onPackageSelect}
          />
        </div>
        {data && data.packages && data.packages[selectedPackage]?.cab_list && (
          <div id={`carTypeRouteCars`}>
            <RouteCarTypeCabs
              templateType={CITY_HR}
              data={data.packages[selectedPackage].cab_list}
              carTypeName={capitalise(HR_STRING)}
              sourceCityName={cityName}
              destinationCityName={cityName}
              seoUrl={''}
              noOfListings={10}
              showCityNameOnCabCard={showCityNameOnCabCard}
            />
          </div>
        )}
      </section>
    </>
  ) : null;
};

export default HourlyRentalsCabs;
